import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import UserAboutEdit from "./edit";
import UserAboutView from "./view";

class UserAbout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_page: 'view',
            is_edit: this.props.props
        }
        this.changeview = this.changeview.bind(this);
       
    }
    changeview(type = 'view') {

        this.setState({
            current_page: type
        });
    }
    call_view_or_edit(){
        switch (this.state.current_page) {
            case 'edit': 
                return <UserAboutEdit urlId={this.props.urlId} changeview={this.changeview} />;
                break;
            default:
                return <UserAboutView changeview={this.changeview} urlId={this.props.urlId} />;
                break;
        }
    }
    render() {
        return (
            <div>
                {this.call_view_or_edit()}
            </div>
        )
    }
}

export default withRouter(UserAbout)
